import { authClientProxy, authClientChoco } from './client';
import { getSettingsFromAuthRequest } from '@/utils-v2/helpers/auth/generateSettingsRequest';
import { grantTypeDictionary } from '@/entities/enums/GrantTypes';
import { getParamsRequest } from '@/utils-v2/helpers/auth/generateParamsRequest';
import { removeCookie, setCookie } from '@/utils-v2/libs/cookieWrapper';

class AuthService {
  url = '/api/v2/oauth2/tokens';
  chocoUrl = `${import.meta.env.VITE_GATEWAY_API_PREFIX}/v0/common/choco/login`;
  logoutUrl = '/api/v1/oauth2/devices';

  //eslint-disable-next-line max-lines-per-function
  async login(code) {
    try {
      const params = getParamsRequest(grantTypeDictionary.code, { code });
      const settings = getSettingsFromAuthRequest();
      const { access_token } = await authClientProxy.post(this.url, params, settings);
      const { tokens } = await authClientChoco.post(this.chocoUrl, { access_token });
      setCookie('auth_token', tokens.access);
      setCookie('holding_token', access_token);
      window.location.href = '/'
    } catch (error) {
      console.error('Ошибка авторизации:', error);
      window.location.href = '/login';
    }
  }

  //eslint-disable-next-line max-lines-per-function
  async logout() {
    const settings = getSettingsFromAuthRequest(true);
    try {
      await authClientProxy.delete(this.logoutUrl, settings);
    } catch (error) {
      console.error('Ошибка при выходе:', error);
    } finally {
      removeCookie('auth_token');
      window.location.href = `${import.meta.env.VITE_AUTH_SERVER}/oauth/logout`;
    }
  }
}

export const authService = new AuthService();
